@app.controller 'JouleLandingLastHeroController', ($element, $rootScope, LocationService, responsiveService, $window, mobileDetectionService, $state, ShopifyService) ->

  console.log $state.currentUser
  # Set Location
  @isInUS = LocationService.isInUS()
  @currentUserPremium = $state.currentUser?.premium
  @currentUserUsedDiscount = $state.currentUser?.used_circulator_discount
  # Drys up the price, however we actually want to use the resolve priceData
  # At the moment priceData does not seem to resolve properly when using ui-sref
  @product = ShopifyService.productForSku 'cs10001'
  @price = @product.price
  @inStock = false

  if @product.inventory_quantity > 0
    @inStock = true
  else
    @inStock = false

  # Responsive Variables
  @isViewportMobile = responsiveService.isViewportMobile()
  @isMobileDevice = mobileDetectionService.isMobile
  @responsiveWidth = responsiveService
  angular.element($window).bind 'resize', =>
    @isViewportMobile = responsiveService.isViewportMobile()
    $rootScope.$safeApply()

  this
